export default {
    approvals: "Approvals",
    delegates: "Delegates",
    employees: "Employees"
}